/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, FC, ReactNode, useContext } from 'react';

export interface SheetContextType {
  isOpen: boolean;
  openSheet: (utilizeQueryParam?: boolean) => void;
  closeSheet: (utilizeQueryParam?: boolean) => void;
}

export const SheetContext = createContext<SheetContextType>({
  isOpen: false,
  openSheet: () => {},
  closeSheet: () => {},
});

export const useSheetContext = () => useContext(SheetContext);

interface SheetProviderProps {
  children: ReactNode;
  isOpen: boolean;
  openSheet: () => void;
  closeSheet: () => void;
}

export const SheetProvider: FC<SheetProviderProps> = ({
  children,
  isOpen,
  openSheet,
  closeSheet,
}) => {
  return (
    <SheetContext.Provider value={{ isOpen, openSheet, closeSheet }}>
      {children}
    </SheetContext.Provider>
  );
};
